import { render } from "./new_text_step.vue?vue&type=template&id=b229782a"
import script from "./new_text_step.vue?vue&type=script&lang=js"
export * from "./new_text_step.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__